export default [{
  name: 'login',
  method: 'POST',
  path: '/vue/account/account-login'
},
{
  name: 'getMenuPermission',
  method: 'GET',
  path: '/'
},
{
  name: 'hxuserregister', // 西北旺环信和web端用户注册
  method: 'POST',
  path: '/vue/imhx/hxuser-register'
},
{
  name: 'sendactivation', // 西北旺环信和web端注册短信验证
  method: 'GET',
  path: '/vue/imhx/send-activation'
},
{
  name: 'updatePasswordByMobile', // 西北旺环信和web端找回密码短信验证
  method: 'POST',
  path: '/vue/imhx/hxuser-updatePasswordByMobile'
},
{
  name: 'getList',
  method: 'GET',
  path: '/vue/account/account-page'
}
];